const styles = theme => ({
  biggerWidth: {
    maxWidth: '624px !important',
    overflow: 'hidden',
  },
  requiredStar: {
    color: theme.palette.primary.main + '!important',
  },
  containerPadding: {
    padding: '24px',
  },
  addActionBtn: {
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '24px',
    textTransform: 'none',
    padding: '9.5px 24px',
    border: `1px solid ${theme.palette.primary.adgmBlack}`,
    borderRadius: '0px',
    [theme.breakpoints.down('xs')]: {
      padding: '16px 24px',
      width: '100%',
      fontWeight: '500',
      fontSize: '14px',
    },
    '& img': {
      marginRight: '0.5em',
    },
  },
  divider: {
    background: '#EBEEF3',
    height: '1px',
    width: '100%',
    [theme.breakpoints.up('md')]: {
      margin: '24px 0px',
    },
  },
  dividerMargin: {
    [theme.breakpoints.down('sm')]: {
      marginTop: '16px',
    },
  },
  mobileActions: {
    textAlign: 'right',
    '& button': {
      color: theme.palette.primary.main,
      textTransform: 'capitalize',
      margin: '0 16px',
      '&:hover': {
        background: 'none',
      },
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateAreas: '"1 1"',
      display: 'grid',
      '& button': {
        color: theme.palette.primary.adgmBlack,
        border: `1px solid ${theme.palette.primary.adgmBlack}`,
        margin: '0px',
        borderRadius: '0px',
        width: '100%',
        padding: '9.5px',
      },
    },
  },
  modelHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid #CED1D6',
    margin: '-16px -40px 25px -40px',
    padding: '0 40px 15px 40px',
    '& img': {
      cursor: 'pointer',
      transition: 'ease-in-out 0.4s',
      '&:hover': {
        filter: 'brightness(0)',
        transition: 'ease-in-out 0.4s',
      },
    },
    '@media (max-width: 768px)': {
      margin: '0px -20px 25px -20px',
    },
  },
  addItemButton: {
    textAlign: 'right',
    '& button': {
      width: '140px',
      height: '56px',
    },
  },
  borderBottom: {
    borderBottom: '1px solid #EBEEF3',
    marginBottom: '20px',
  },
  item: {
    display: 'grid',
    gridTemplateColumns: '2.5fr 2fr 2.5fr 1fr',
    padding: '10px',
    border: 'solid 1px #CED1D6',
    gap: '16px',
    alignItems: 'center',
    borderRadius: '0px',
    marginBottom: '15px',
    '& p': {
      width: '100%',
      fontWeight: 500,
      fontSize: '1em',
      margin: 0,
      lineHeight: '1.5em',
    },
    '& div': {
      display: 'flex',
      gap: '10px',
      '& span': {
        cursor: 'pointer',
        transition: 'ease-in-out 0.3s',
        whiteSpace: 'nowrap',
        '&:hover': {
          transition: 'ease-in-out 0.3s',
          color: '#130F26',
        },
      },
    },
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexWrap: 'wrap',
      '& p': {
        width: '100%',
      },
      '& div': {
        width: '100%',
        justifyContent: 'end',
      },
    },
  },
  btn: {
    color: '#8C9099',
    cursor: 'pointer',
    transition: 'ease-in-out 0.3s',
    whiteSpace: 'nowrap',
    '&:hover': {
      transition: 'ease-in-out 0.3s',
      color: '#130F26',
    },
  },
  index: {
    width: '40px',
    height: '32px',
    display: 'block',
    lineHeight: '32px',
    fontWeight: 600,
    textAlign: 'center',
    backgroundColor: '#EBEEF3',
    borderRadius: '0px',
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '@media (max-width: 600px)': {
      flexDirection: 'column-reverse',
      gap: '16px',
    },
  },
  claimText: {
    '& p': {
      fontSize: '16px',
      fontWeight: '500',
    },
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
      padding: '16px',
      border: '1px solid #CED1D6',
      width: '100%',
    },
  },
  divider1px: {
    height: '1px',
    width: '100%',
    background: '#EBEEF3',
  },
  itemReadOnly: {
    [theme.breakpoints.up('md')]: {
      display: 'grid',
      gridTemplateColumns: '2.5fr 2fr 2fr',
      '& p': {
        width: '100%',
        fontWeight: 500,
        fontSize: '1em',
      },
      '& div': {
        display: 'flex',
        gap: '10px',
      },
    },
    [theme.breakpoints.down('md')]: {
      padding: '1em',
      '&:last-child': {
        margin: 0,
      },
    },
  },
  modifiedIndex: {
    width: '40px',
    height: '32px',
    display: 'block',
    lineHeight: '32px',
    fontWeight: 600,
    textAlign: 'center',
  },
  claimTextModified: {
    width: '100%',
    background: theme.palette.primary.adgmGreenLight,
    color: theme.palette.primary.adgmBlack,
    border: `1px solid ${theme.palette.secondary.disableLightGray}`,
    borderRadius: '0px',
    padding: '1em',
    [theme.breakpoints.down('sm')]: {
      marginTop: '16px',
    },
  },
  viewMoreWrapper: {
    padding: '0px',
    [theme.breakpoints.down('sm')]: {
      margin: '16px 0px',
    },
    '& a': {
      color: theme.palette.primary.adgmBlack,
    },
  },
});

export default styles;
